// react-native-web maps TouchableNativeFeedback → UnimplementedView (renders its
// child in a plain View with NO press handling), so every `<TouchableNativeFeedback
// onPress>` in the app is DEAD on web. Replace it with a TouchableOpacity-backed
// component that actually fires onPress. Wired via NormalModuleReplacementPlugin
// in webpack.web.config.js (RNW exports it as a read-only getter → not runtime-patchable).
const React = require("react");
const TouchableOpacity = require("react-native-web/dist/exports/TouchableOpacity").default;

function TouchableNativeFeedback(props) {
  const { background, useForeground, children, ...rest } = props || {};
  return React.createElement(TouchableOpacity, Object.assign({ activeOpacity: 0.7 }, rest), children);
}

TouchableNativeFeedback.Ripple = (color, borderless) => ({ type: "RippleAndroid", color, borderless });
TouchableNativeFeedback.SelectableBackground = (r) => ({ type: "ThemeAttrAndroid", attribute: "selectableItemBackground", rippleRadius: r });
TouchableNativeFeedback.SelectableBackgroundBorderless = (r) => ({ type: "ThemeAttrAndroid", attribute: "selectableItemBackgroundBorderless", rippleRadius: r });
TouchableNativeFeedback.canUseNativeForeground = () => false;

module.exports = { __esModule: true, default: TouchableNativeFeedback };
